<app-crear-editar
  [loading]="!form"
  [title]="title"
  [subtitle]="subtitle"
  icono="directions_car"
>
  @if (form) {
    <form
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
      id="form"
    >
      <div class="form-pasos-layout">
        <app-pasos-nav
          [stepper]="stepper"
          etiqueta="Pasos del vehículo"
        ></app-pasos-nav>

        <mat-stepper #stepper [linear]="false" class="form-pasos-stepper">
          <mat-step
            [stepControl]="form.controls['identificacion']"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>Datos</ng-template>
            <app-content-card title="Datos" icon="directions_car">
              <!-- Identificación y Estado -->
              <section class="inputs-group">
                <div class="form-field-wrapper" style="width: 100%">
                  <mat-form-field class="no-hint" style="width: 100%">
                    <mat-label>Identificación</mat-label>
                    <input
                      matInput
                      formControlName="identificacion"
                      [errorStateMatcher]="chequeo.matcher"
                    />
                    <mat-icon matPrefix>badge</mat-icon>
                  </mat-form-field>
                  <app-mensaje-identificacion
                    [chequeo]="chequeo"
                  ></app-mensaje-identificacion>
                </div>

                <ng-container [formGroup]="vehiculoForm">
                  <ng-select
                    style="width: 100%"
                    formControlName="estado"
                    placeholder="Estado"
                    [items]="estados"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                </ng-container>
              </section>

              <!-- Tipo y Función -->
              <section class="inputs-group">
                <ng-container [formGroup]="vehiculoForm">
                  <ng-select
                    style="width: 100%"
                    formControlName="tipo"
                    placeholder="Tipo"
                    [items]="opcionesTipo"
                    bindValue="valor"
                    bindLabel="etiqueta"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                </ng-container>

                <ng-select
                  style="width: 100%"
                  formControlName="funcion"
                  placeholder="Función"
                  [items]="opcionesFuncion"
                  bindValue="valor"
                  bindLabel="etiqueta"
                  appendTo="body"
                  notFoundText="Sin resultados"
                ></ng-select>
              </section>
            </app-content-card>
          </mat-step>
          <mat-step
            [stepControl]="form.controls['idCliente']"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>Cliente y atención</ng-template>
            <app-content-card title="Cliente y atención" icon="business">
              <div class="client-section-wrapper">
                <div class="client-fields">
                  <section class="inputs-group">
                    <!-- Cliente Propietario -->
                    @if (!helper.esClienteFinal() && !vehiculo) {
                      <div style="width: 100%">
                        <label class="field-label">Cliente Propietario</label>
                        <div style="display: flex; gap: 8px">
                          <app-cliente-selector
                            formControlName="idCliente"
                            (clienteChange)="onClienteChange($event)"
                            style="flex: 1"
                            [filterModules]="['moduloVehiculos']"
                            [showCrearBtn]="
                              helper.tienePermiso(
                                'Administración - Crear clientes'
                              )
                            "
                          ></app-cliente-selector>
                        </div>
                      </div>
                    }

                    <!-- Horarios de atención -->
                    <div style="width: 100%">
                      <app-config-horarios-atencion
                        formControlName="configHorariosAtencion"
                        [idClienteFinal]="idCliente"
                      ></app-config-horarios-atencion>
                    </div>

                    <!-- Horarios de atención técnica -->
                    <div style="width: 100%">
                      <app-config-horarios-atencion
                        formControlName="configHorariosAtencionTecnica"
                        titulo="Clientes que Atienden Servicios Técnicos"
                        [idClienteFinal]="idCliente"
                      ></app-config-horarios-atencion>
                    </div>

                    <!-- Puede solicitar servicio técnico -->
                    <mat-checkbox
                      color="primary"
                      formControlName="puedeSolicitarServicioTecnico"
                    >
                      Puede solicitar servicio técnico (permite que el cliente
                      genere solicitudes de servicio técnico desde su app)
                    </mat-checkbox>
                  </section>
                </div>

                <!-- Gráfico de jerarquía de clientes -->
                @if (idCliente) {
                  <div class="client-hierarchy">
                    <app-jerarquia-cliente
                      [idCliente]="idCliente"
                    ></app-jerarquia-cliente>
                  </div>
                }
              </div>
            </app-content-card>
          </mat-step>
          <mat-step optional>
            <ng-template matStepLabel>Asignaciones</ng-template>
            <app-content-card title="Asignaciones" icon="link">
              <!-- Tracker y Grupo -->
              <section class="inputs-group">
                <!-- Tracker -->
                <div style="width: 100%">
                  <label class="field-label">Tracker</label>
                  <div style="display: flex; gap: 8px">
                    <ng-select
                      [fixedPlaceholder]="true"
                      [items]="trackers"
                      bindLabel="nombre"
                      bindValue="_id"
                      formControlName="idTracker"
                      placeholder="Tracker"
                      [notFoundText]="'No hay trackers disponibles'"
                      style="flex: 1"
                      appendTo="body"
                    ></ng-select>
                    <app-button
                      [disabled]="!this.form.value.idCliente"
                      matType="mat-fab"
                      color="primary"
                      icon="add"
                      [tooltip]="'Crear tracker'"
                      (click)="form?.value?.idCliente ? crearTracker() : null"
                    ></app-button>
                  </div>
                </div>

                <!-- Grupo -->

                <div style="width: 100%">
                  <label class="field-label">Flota</label>
                  <app-grupo-selector
                    [idCliente]="form?.get('idCliente')?.value"
                    categoria="Flota"
                    placeholder="Flota"
                    formControlName="idGrupo"
                    [showCrearBtn]="
                      helper.tienePermiso('Vehículos - Crear flotas')
                    "
                  ></app-grupo-selector>
                </div>
              </section>

              <!-- Dashcam: independiente del tracker (puede tener los dos) -->
              <section class="inputs-group">
                <div style="width: 100%">
                  <label class="field-label">Dashcam</label>
                  <div style="display: flex; gap: 8px">
                    <ng-select
                      [items]="dashcams"
                      bindLabel="nombre"
                      bindValue="_id"
                      formControlName="idDashcam"
                      placeholder="Dashcam"
                      notFoundText="No hay dashcams disponibles"
                      style="flex: 1"
                      appendTo="body"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.nombre }}
                        @if (item.uniqueId) {
                          <small class="ng-option-client">
                            {{ item.uniqueId }}
                          </small>
                        }
                      </ng-template>
                    </ng-select>
                    @if (
                      helper.tienePermiso('Administración - Crear dashcams')
                    ) {
                      <button
                        irxBotonIcono="borde"
                        tamano="campo"
                        tono="primario"
                        type="button"
                        tooltip="Crear dashcam"
                        [disabled]="!form.value.idCliente"
                        (click)="crearDashcam()"
                      >
                        <mat-icon>add</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              </section>

              <!-- Conductor y Recorrido -->
              <section class="inputs-group">
                <!-- Conductor -->
                <div style="width: 100%" [formGroup]="vehiculoForm">
                  <label class="field-label">Conductor</label>
                  <ng-select
                    [items]="conductores"
                    formControlName="idChofer"
                    bindLabel="label"
                    bindValue="_id"
                    placeholder="Buscar conductor"
                    style="margin: 0"
                    searchable="true"
                    appendTo="body"
                    [virtualScroll]="true"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ng-option-content">
                        <strong>
                          {{ item.datosPersonales?.nombre || item.usuario }}
                        </strong>
                        @if (item.datosPersonales?.nombre) {
                          <small class="ng-option-client">
                            {{ item.usuario }}
                          </small>
                        }
                      </div>
                    </ng-template>
                  </ng-select>
                </div>

                <!-- Recorrido -->
                <div style="width: 100%">
                  <label class="field-label">Recorrido</label>
                  <div
                    style="display: flex; gap: 8px"
                    [formGroup]="vehiculoForm"
                  >
                    <ng-select
                      [fixedPlaceholder]="true"
                      [items]="recorridos()"
                      bindLabel="nombre"
                      bindValue="_id"
                      formControlName="idRecorrido"
                      placeholder="Recorrido"
                      [notFoundText]="'No hay recorridos disponibles'"
                      style="flex: 1"
                      appendTo="body"
                    ></ng-select>
                    <app-button
                      [disabled]="!this.form.value.idCliente"
                      matType="mat-fab"
                      color="primary"
                      icon="add"
                      [tooltip]="'Crear recorrido'"
                      (click)="form?.value?.idCliente ? crearRecorrido() : null"
                    ></app-button>
                  </div>
                </div>
              </section>
            </app-content-card>
          </mat-step>
          <mat-step optional>
            <ng-template matStepLabel>Información</ng-template>
            <app-content-card
              title="Información"
              icon="info"
              [formGroup]="vehiculoForm"
            >
              <!-- Patente y Marca -->
              <section class="inputs-group">
                <div style="flex: 1; min-width: 0">
                  <mat-form-field style="width: 100%">
                    <mat-label>Patente</mat-label>
                    <input matInput formControlName="patente" />
                    <mat-icon matPrefix>pin</mat-icon>
                  </mat-form-field>

                  <!-- Advertencia, no bloquea el guardado: el vehículo se carga igual
                 pero no se sincroniza con Soflex -->
                  @if (patenteInvalida) {
                    <app-hint
                      color="yellow"
                      icon="warning"
                      message="La patente no tiene un formato argentino válido (ABC123, AA123AA, 123ABC, A123BCD o ABC12). Se puede guardar igual."
                    ></app-hint>
                  }
                </div>

                <mat-form-field style="width: 100%; flex: 1">
                  <mat-label>Marca</mat-label>
                  <input matInput formControlName="marca" />
                  <mat-icon matPrefix>business</mat-icon>
                </mat-form-field>
              </section>

              <!-- Modelo y Año -->
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Modelo</mat-label>
                  <input matInput formControlName="modelo" />
                  <mat-icon matPrefix>directions_car</mat-icon>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Año</mat-label>
                  <input matInput formControlName="anio" type="number" />
                  <mat-icon matPrefix>calendar_today</mat-icon>
                </mat-form-field>
              </section>

              <!-- Identificación externa y modo de consumo -->
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Identificación Externa</mat-label>
                  <input matInput formControlName="idExterno" />
                  <mat-icon matPrefix>qr_code</mat-icon>
                </mat-form-field>

                <div style="width: 100%">
                  <ng-select
                    style="width: 100%"
                    formControlName="modoConsumo"
                    placeholder="Consumo promedio por"
                    [items]="opcionesModoConsumo"
                    bindValue="valor"
                    bindLabel="etiqueta"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                  <small class="ayuda">
                    Cómo se muestra el consumo medido por el sensor
                  </small>
                </div>
              </section>

              <!-- Consumo y tanque -->
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Consumo en ruta</mat-label>
                  <input
                    matInput
                    formControlName="consumoRuta"
                    type="number"
                    min="0"
                  />
                  <mat-icon matPrefix>local_gas_station</mat-icon>
                  <mat-hint>Litros cada 100 km (ruta)</mat-hint>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Consumo en ciudad</mat-label>
                  <input
                    matInput
                    formControlName="consumoCiudad"
                    type="number"
                    min="0"
                  />
                  <mat-icon matPrefix>local_gas_station</mat-icon>
                  <mat-hint>Litros cada 100 km (ciudad)</mat-hint>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Capacidad del tanque</mat-label>
                  <input
                    matInput
                    formControlName="capacidadCombustible"
                    type="number"
                    min="0"
                  />
                  <mat-icon matPrefix>local_gas_station</mat-icon>
                  <mat-hint>Litros</mat-hint>
                </mat-form-field>
              </section>
            </app-content-card>
          </mat-step>
        </mat-stepper>
      </div>
    </form>
  }

  @if (form && stepper) {
    <ng-container actions>
      <button irxBoton="secundario" type="button" (click)="volver()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      <button
        irxBoton="secundario"
        type="button"
        (click)="stepper.previous()"
        [disabled]="stepper.selectedIndex === 0"
      >
        <mat-icon>chevron_left</mat-icon>
        Anterior
      </button>
      @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
      <!-- Con el formulario válido, Guardar es la acción principal y
           Siguiente pasa a secundario -->
      @if (!ultimo && form.valid) {
        <button irxBoton="secundario" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      } @else if (!ultimo) {
        <button irxBoton="principal" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      }
      <button
        irxBoton="principal"
        type="submit"
        form="form"
        [disabled]="!form.valid || loading"
      >
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </ng-container>
  }
</app-crear-editar>
